export const WORKER_URL = new URL('./worker.js', import.meta.url);
